const user = {
  name: null,
  friends_names: ['Alex Porter', 'Oliver Blackshire', 'Freddy Essex', 'Laura Barnes', 'Valia Brady', 'Danny Kalfa', 'Andy Sturrock', 'Mark Kennan'],
  locations:
  {
    user: {},
    friends: [],
  },
  sections: [
  {
    default_name: 'valued customer',
    label: 'e-commerce',
    els: Array.from( cached_elements.get_nodelist( '.e-commerce .js-user-name' ) )
  },
  {
    default_name: 'xxxxx',
    label: 'news',
    els: Array.from( cached_elements.get_nodelist( '.news .js-user-name' ) )
  },
  {
    default_name: 'anonymous',
    label: 'social',
    els: Array.from( cached_elements.get_nodelist( '.social .js-user-name' ) )
  } ]
}


const add_name_to_sections = () =>
{
  for ( const section in user.sections )
  {
    update_section_name( user.sections[ section ].els, user.sections[ section ].default_name, user.sections[ section ].label );
  }
}


const update_section_name = ( section_els, default_name, label ) =>
{
  for ( const el of section_els )
  {
    el.textContent = user.name ? user.name : default_name;
    label === 'news' && !user.name ? el.classList.add( 'retracted' ) : false;
  }
}